import * as React from "react"

const WebApp = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="currentcolor"
    {...props}
  >
    <title>web-app</title>
    <path
      d="M21 10h-6a1 1 0 00-1 1v10a1 1 0 001 1h6a1 1 0 001-1V11a1 1 0 00-1-1zm-1 9h-4v-7h4v7zm1-11h-2V5.5a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5V13a1 1 0 001 1h6v3H3a2 2 0 01-2-2h2.78A2.98 2.98 0 013 13V5.5A2.5 2.5 0 015.5 3h13A2.5 2.5 0 0121 5.5V8z"
      fillRule="evenodd"
    />
  </svg>
)

export default WebApp
